import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Box, Spinner } from '@cloudscape-design/components';

import { getAuthToken } from '../auth/useAuth';
import { getDistributorToken } from '../auth/useDistributorAuth';

const MANAGE_URL = 'https://manage.realtimefeedback.com';

export const Route = createFileRoute('/')({
  component: RootDispatch,
});

function RootDispatch() {
  const navigate = useNavigate();

  useEffect(() => {
    if (getAuthToken()) {
      navigate({ to: '/dashboard' });
      return;
    }
    if (getDistributorToken()) {
      navigate({ to: '/distributor' });
      return;
    }
    window.location.href = MANAGE_URL;
  }, [navigate]);

  return (
    <Box padding="xxl" textAlign="center">
      <Spinner size="large" />
    </Box>
  );
}
